import { IconButton } from '@/decodo/components/atoms/IconButton';
import { useMediaPlayback } from '@/hooks/useMediaPlayback';
import { cn } from '@/lib/utils';
import { useEffect } from 'react';
import IconPause from '~/icons/pause-square.svg';
import IconPlay from '~/icons/play-square.svg';

// Separated mobile video into its own component to avoid ref conflicts.
// mediaRef cannot reliably be shared across desktop and mobile <video> elements,
// as only one can be bound at a time. Isolating mobile prevents unintended playback bugs.

export const VideoPlayerMobile = ({ src }: { src?: string }) => {
  const {
    handleMount,
    mediaRef,
    togglePlay,
    isPlaying,
    _setIsPlaying,
    _setMediaLength,
  } = useMediaPlayback<HTMLVideoElement>();

  useEffect(() => {
    handleMount();
    _setIsPlaying(true);
  }, [src]);

  const PlayPauseButton = () => (
    <IconButton
      onClick={() => {
        togglePlay();
      }}
      noStyles
      className={cn(
        'text-base-white dark:text-base-black',
        'absolute bottom-0 left-0 z-50 m-4 h-6 w-6 stroke-2'
      )}
    >
      {isPlaying ? <IconPause /> : <IconPlay />}
    </IconButton>
  );

  return (
    <div className='relative rounded bg-gray-100 pb-[100%] dark:bg-gray-800'>
      <PlayPauseButton />
      <video
        id='mobile-video'
        onClick={togglePlay}
        ref={mediaRef}
        className='absolute h-full w-auto rounded object-cover'
        onLoad={handleMount}
        src={src}
        controls={false}
        muted
        autoPlay
        loop
        onLoadedData={(e) => {
          _setMediaLength(e.currentTarget.duration);
        }}
      />
    </div>
  );
};
